import React from 'react';
import { Box, Typography, Link } from '@mui/material';
import { useTranslation } from 'react-i18next';
import { 
  privacyPageStyles, 
  heroSectionStyles, 
  contentSectionStyles, 
  privacySectionStyles 
} from './styles';

export const Privacy = () => {
  const { t } = useTranslation();

  return (
    <Box sx={privacyPageStyles.container}>
      {/* Hero Section */}
      <Box sx={heroSectionStyles.background}>
        <Box sx={heroSectionStyles.content}>
          <Typography 
            variant="h1" 
            sx={heroSectionStyles.title}
          >
            {t('ecommerce.privacy.hero.title', 'Privacy Policy')}
          </Typography>
          <Typography 
            variant="h2" 
            sx={heroSectionStyles.subtitle}
          >
            {t('ecommerce.privacy.hero.subtitle', 'Learn how we protect and handle your personal information on SYL Roofing Supply platform.')}
          </Typography>
        </Box>
      </Box>

      {/* Content Section */}
      <Box sx={contentSectionStyles.container}>
        <Box sx={contentSectionStyles.wrapper}>
          {/* Last Updated */}
          <Box sx={{ textAlign: 'center', mb: 4 }}>
            <Typography variant="body2" sx={{ color: '#5A7184', fontSize: '0.875rem' }}>
              {t('ecommerce.privacy.lastUpdated')}: {t('ecommerce.privacy.lastUpdatedDate')}
            </Typography>
          </Box>

          {/* Introduction */}
          <Box sx={privacySectionStyles.container}>
            <Typography variant="h3" sx={privacySectionStyles.title}>
              {t('ecommerce.privacy.introduction.title')}
            </Typography>
            <Typography variant="body1" sx={privacySectionStyles.content}>
              {t('ecommerce.privacy.introduction.content')}
            </Typography>
          </Box>

          {/* Data Collection */}
          <Box sx={privacySectionStyles.container}>
            <Typography variant="h3" sx={privacySectionStyles.title}>
              {t('ecommerce.privacy.dataCollection.title')}
            </Typography>
            
            <Typography variant="h4" sx={privacySectionStyles.subtitle}>
              {t('ecommerce.privacy.dataCollection.personal.title')}
            </Typography>
            <Typography variant="body1" sx={privacySectionStyles.content}>
              {t('ecommerce.privacy.dataCollection.personal.content')}
            </Typography>

            <Typography variant="h4" sx={privacySectionStyles.subtitle}>
              {t('ecommerce.privacy.dataCollection.usage.title')}
            </Typography>
            <Typography variant="body1" sx={privacySectionStyles.content}>
              {t('ecommerce.privacy.dataCollection.usage.content')}
            </Typography>

            <Typography variant="h4" sx={privacySectionStyles.subtitle}>
              {t('ecommerce.privacy.dataCollection.device.title')}
            </Typography>
            <Typography variant="body1" sx={privacySectionStyles.content}>
              {t('ecommerce.privacy.dataCollection.device.content')}
            </Typography>
          </Box>

          {/* Data Usage */}
          <Box sx={privacySectionStyles.container}>
            <Typography variant="h3" sx={privacySectionStyles.title}>
              {t('ecommerce.privacy.dataUsage.title')}
            </Typography>
            <Typography variant="body1" sx={privacySectionStyles.content}>
              {t('ecommerce.privacy.dataUsage.content')}
            </Typography>
            <Box component="ul" sx={privacySectionStyles.list}>
              <Typography component="li" variant="body1" sx={privacySectionStyles.listItem}>
                {t('ecommerce.privacy.dataUsage.point1')}
              </Typography>
              <Typography component="li" variant="body1" sx={privacySectionStyles.listItem}>
                {t('ecommerce.privacy.dataUsage.point2')}
              </Typography>
              <Typography component="li" variant="body1" sx={privacySectionStyles.listItem}>
                {t('ecommerce.privacy.dataUsage.point3')}
              </Typography>
              <Typography component="li" variant="body1" sx={privacySectionStyles.listItem}>
                {t('ecommerce.privacy.dataUsage.point4')}
              </Typography>
              <Typography component="li" variant="body1" sx={privacySectionStyles.listItem}>
                {t('ecommerce.privacy.dataUsage.point5')}
              </Typography>
            </Box>
          </Box>

          {/* Data Sharing */}
          <Box sx={privacySectionStyles.container}>
            <Typography variant="h3" sx={privacySectionStyles.title}>
              {t('ecommerce.privacy.dataSharing.title')}
            </Typography>
            <Typography variant="body1" sx={privacySectionStyles.content}>
              {t('ecommerce.privacy.dataSharing.content')}
            </Typography>
            <Box component="ul" sx={privacySectionStyles.list}>
              <Typography component="li" variant="body1" sx={privacySectionStyles.listItem}>
                {t('ecommerce.privacy.dataSharing.point1')}
              </Typography>
              <Typography component="li" variant="body1" sx={privacySectionStyles.listItem}>
                {t('ecommerce.privacy.dataSharing.point2')}
              </Typography>
              <Typography component="li" variant="body1" sx={privacySectionStyles.listItem}>
                {t('ecommerce.privacy.dataSharing.point3')}
              </Typography>
            </Box>
          </Box>

          {/* Security */}
          <Box sx={privacySectionStyles.container}>
            <Typography variant="h3" sx={privacySectionStyles.title}>
              {t('ecommerce.privacy.security.title')}
            </Typography>
            <Typography variant="body1" sx={privacySectionStyles.content}>
              {t('ecommerce.privacy.security.content')}
            </Typography>
          </Box>

          {/* Rights */}
          <Box sx={privacySectionStyles.container}>
            <Typography variant="h3" sx={privacySectionStyles.title}>
              {t('ecommerce.privacy.rights.title')}
            </Typography>
            <Typography variant="body1" sx={privacySectionStyles.content}>
              {t('ecommerce.privacy.rights.content')}
            </Typography>
            <Box component="ul" sx={privacySectionStyles.list}>
              <Typography component="li" variant="body1" sx={privacySectionStyles.listItem}>
                {t('ecommerce.privacy.rights.point1')}
              </Typography>
              <Typography component="li" variant="body1" sx={privacySectionStyles.listItem}>
                {t('ecommerce.privacy.rights.point2')}
              </Typography>
              <Typography component="li" variant="body1" sx={privacySectionStyles.listItem}>
                {t('ecommerce.privacy.rights.point3')}
              </Typography>
              <Typography component="li" variant="body1" sx={privacySectionStyles.listItem}>
                {t('ecommerce.privacy.rights.point4')}
              </Typography>
            </Box>
          </Box>

          {/* Contact */}
          <Box sx={privacySectionStyles.container}>
            <Typography variant="h3" sx={privacySectionStyles.title}>
              {t('ecommerce.privacy.contact.title')}
            </Typography>
            <Typography variant="body1" sx={privacySectionStyles.content}>
              {t('ecommerce.privacy.contact.content')}
            </Typography>
            <Typography variant="body1" sx={privacySectionStyles.contactInfo}>
              <strong>{t('ecommerce.privacy.contact.phone')}:</strong>{' '}
              <Link href="tel:+13213309934" sx={privacySectionStyles.link}>
                +1 (321) 330-9934
              </Link>
            </Typography>
            <Typography variant="body1" sx={privacySectionStyles.contactInfo}>
              <strong>Email:</strong>{' '}
              <Link href="mailto:quote@sylroofingsupply.com" sx={privacySectionStyles.link}>
                quote@sylroofingsupply.com
              </Link>
            </Typography>
          </Box>

          {/* Footer */}
          <Box sx={privacySectionStyles.footer}>
            <Typography variant="body2" sx={{ color: '#5A7184', fontSize: '0.875rem' }}>
              © 2024 SYL Roofing Supply. {t('ecommerce.privacy.footer')}.
            </Typography>
          </Box>
        </Box>
      </Box>
    </Box>
  );
};

export default Privacy; 